import ClassicExtension from "./ClassicExtension";

export default class ModalExtension extends ClassicExtension {

    private stackEventsInitialized = false;

    protected init($root: JQuery): void {
        this.initStackEvents();

        $root.find('[data-toggle="modal"]').each( (i,el) => {
            el.addEventListener('click', e => {
                e.preventDefault();
                const target = el.dataset.target;
                if (el.dataset.target) {
                    $(target).modal('show');
                }
            });
        });

        // update modal positioning
        $root.find('.modal[data-bs-reposition]').each(function(index, item) {
            if ($($(item).data('bs-reposition')).length > 0) {
                $(item).appendTo($(item).data('bs-reposition'));
            }
        });
    }

    private initStackEvents(): void {
        if (this.stackEventsInitialized) {
            return;
        }

        this.stackEventsInitialized = true;
        document.addEventListener('show.bs.modal', event => this.stackModal(event));
        document.addEventListener('hidden.bs.modal', () => this.restoreModalState());
    }

    private stackModal(event: Event): void {
        const modal = event.target;

        if (!(modal instanceof HTMLElement) || !modal.classList.contains('modal')) {
            return;
        }

        if ($(modal).parents('.modal.show').length > 0) {
            return;
        }

        const zIndex = 1055 + ($('.modal.show').length * 20);
        modal.style.zIndex = zIndex.toString();

        window.setTimeout(() => {
            $('.modal-backdrop:not(.modal-stack)')
                .last()
                .css('z-index', zIndex - 5)
                .addClass('modal-stack');
        });
    }

    private restoreModalState(): void {
        if ($('.modal.show').length > 0) {
            $(document.body).addClass('modal-open');
            return;
        }

        $('.modal-backdrop.modal-stack')
            .removeClass('modal-stack')
            .css('z-index', '');
    }
}
